__turbopack_context__.v({
  "input-preview__label": "input-preview-module-scss-module__tV6Weq__input-preview__label",
  "input-preview__value": "input-preview-module-scss-module__tV6Weq__input-preview__value",
});
